<template>
  <div class="trainer-nickname">
    <weui-group :title="`原备注名为“${trainer.name_remarks || ''}”`">
      <weui-input label="备注名" v-model="nickname" placeholder="请输入新的备注名" />
    </weui-group>
    <weui-button-area>
      <weui-button @click="save">设置新的备注名</weui-button>
    </weui-button-area>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { WeuiGroup, WeuiInput, WeuiButtonArea, WeuiButton } from '@/components/weui';
import { FETCH_TRAINER, PATCH_TRAINER } from '@/store/trainer/types';

const { mapState, mapActions } = createNamespacedHelpers('trainer');

export default {
    data() {
        return {
            id: 0,
            nickname: null,
        };
    },
    created() {
        const { id } = this.$route.params;
        this.id = Number.parseInt(id, 10);
        this.fetchTrainer({
            id,
        }).then(() => {
            document.title = `会员：${this.trainer.name}`;
        });
    },
    computed: {
        ...mapState({
            trainer: state => state.trainer || {},
        }),
    },
    watch: {
        trainer(val) {
            this.nickname = val.name_remarks;
        },
    },
    methods: {
        ...mapActions({
            fetchTrainer: FETCH_TRAINER,
            patchTrainer: PATCH_TRAINER,
        }),
        async save() {
            const { id } = this.trainer;

            await this.patchTrainer({
                trainer: {
                    id,
                    name_remarks: this.nickname,
                },
            });
            this.$router.go(-1);
        },
    },
    components: {
        WeuiGroup,
        WeuiInput,
        WeuiButtonArea,
        WeuiButton,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/trainer/Nickname.vue